import { styled } from '@mui/system';

export const SignUpVerifyFormContainer = styled('div')(() => ({
  flex: 1,
}));

export const Container = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
